Vue.component('CartIndicator', {    
  props: ['count'],    
  template: `  
    <span>{{ count }}</span>  
  `
})

Vue.component('Cart', {  
  props: ['cart'],
  methods: {
    formattedPrice(price) {
      return '$' + (price / 100 ).toFixed(2);
    },
    checkoutUrl(token) {
      return '/checkouts/cn/' + token
    }
  },
  template: `
    <div class="[ flex flex-col justify-betweeen ][ h-full ]">
      <p class="[ text-3xl ]">{{ cart.item_count }} items in your cart</p>
      <ul class="scrollable-element [ px-0 ][ overflow-auto ]">
        <cart-item v-for="(item, index) in cart.items" :item="item" :quantity="item.quantity" :key="index"></cart-item>
      </ul>
      <div class="[ mt-auto ]">
        <div class="[ mt-8 mb-4 ][ text-2xl ][ flex justify-between gap-x-4 ]">
          <span class="[ font-ss-medium ]">Cart Total</span>
          <span>{{ formattedPrice(cart.total_price) }}</span>
        </div>
        <a :href="checkoutUrl(cart.token)" class="[ btn ][ justify-center ][ w-[calc(100%-40px)] ]">Checkout</a>
      </div>
    </div>
  `
})

Vue.component('CartItem', {  
  props: ['item', 'quantity'],
  methods: {
    formattedPrice(price) {
      return '$' + (price / 100 ).toFixed(2);
    },
    removeItem(item) {

      let data = {
        'id': `${item.variant_id}`,
        'quantity': 0        
      }      
    
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {  
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
      
    },
  },
  template: `
  <li class="cart-item [ flex gap-x-6 ][ mb-6 pb-6 ][ border-b border-sb-gold-light/20 last:border-0 ]">
    <div class="[ relative ][ aspect-square ][ overflow-hidden][ h-24 w-24 ]">
      <img :src="item.featured_image.url + '&width=240'" width="120" class="[ absolute top-0 left-0 ][ w-full h-full ][ aspect-sqaure object-cover object-center ]" />
    </div>
    <div>
      <h4 class="[ text-2xl font-sans ][ mt-0 mb-1 ]">{{ item.product_title }}</h4>
      <span v-if="item.variant_title" class="[ block ][ text-sb-gold-light opacity-50 ][ mb-4 ]">{{ item.variant_title }}</span>
      <cart-qty :item="item" :itemQuantity="quantity"></cart-qty>
    </div>
    <div class="[ flex flex-col items-end justify-between ][ ml-auto ]">
      <div>{{ formattedPrice(item.final_line_price) }}</div>
      <button @click="removeItem(item)">
        <span class="[ sr-only ]">Close</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g>
            <path id="Vector" d="M17.6688 1.74066H13.2438L12.897 1.05316C12.8241 0.905758 12.7114 0.781693 12.5717 0.694989C12.432 0.608286 12.2708 0.562404 12.1063 0.562531H7.89072C7.72643 0.561144 7.56514 0.606543 7.42569 0.693422C7.28624 0.780301 7.17439 0.905072 7.10322 1.05316L6.75635 1.74066H2.33135C2.1747 1.74066 2.02448 1.80288 1.91371 1.91365C1.80295 2.02441 1.74072 2.17464 1.74072 2.33128V3.51253C1.74155 3.66863 1.80414 3.81806 1.91481 3.92815C2.02549 4.03824 2.17524 4.10003 2.33135 4.10003H17.6688C17.8249 4.10003 17.9747 4.03824 18.0854 3.92815C18.1961 3.81806 18.2586 3.66863 18.2595 3.51253V2.33128C18.2595 2.17464 18.1972 2.02441 18.0865 1.91365C17.9757 1.80288 17.8255 1.74066 17.6688 1.74066ZM2.92197 5.28128L3.70322 17.7813C3.73183 18.2301 3.9303 18.6511 4.25829 18.9588C4.58628 19.2665 5.01914 19.4376 5.46885 19.4375H14.5313C14.9816 19.4376 15.4149 19.266 15.7429 18.9577C16.071 18.6493 16.2691 18.2275 16.297 17.7782L17.0782 5.27816L2.92197 5.28128ZM8.25322 16.4938C8.24754 16.7433 8.14481 16.9808 7.96685 17.1559C7.78889 17.3309 7.54971 17.4297 7.3001 17.4313C7.04994 17.4305 6.80997 17.3321 6.63134 17.157C6.45271 16.9818 6.34955 16.7439 6.34385 16.4938V8.22815C6.34467 7.9748 6.44568 7.73205 6.62484 7.55289C6.80399 7.37374 7.04674 7.27273 7.3001 7.2719C7.55291 7.27355 7.79486 7.37493 7.97334 7.55399C8.15182 7.73306 8.2524 7.97533 8.25322 8.22815V16.4938ZM13.6563 16.4938C13.6506 16.7439 13.5475 16.9818 13.3689 17.157C13.1902 17.3321 12.9503 17.4305 12.7001 17.4313C12.4532 17.4257 12.218 17.3252 12.0433 17.1505C11.8687 16.9759 11.7682 16.7407 11.7626 16.4938V8.22815C11.7633 7.978 11.8618 7.73803 12.0369 7.5594C12.212 7.38077 12.45 7.27761 12.7001 7.2719C12.9535 7.27273 13.1962 7.37374 13.3754 7.55289C13.5545 7.73205 13.6555 7.9748 13.6563 8.22815V16.4938Z" fill="white"/>
          </g>
        </svg>
      </button>
    </div>
  </li>
`
})

Vue.component('CartQty', {  
  props: ['item','itemQuantity'],  
  data() {
    return {
      loading: false
    }
  },
  computed: {
    quantity: {
      get() {
        return this.itemQuantity
      },
      set(newValue){
        return newValue
      }      
    }
  },
  methods: {
    async updateItemQty(id, value) {
      this.loading = true
      let data = {
        'id': `${id}`,
        'quantity': value
      }
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {  
        return response.json();
      })      
      .catch((error) => {
        console.error('Error:', error);
      });
      setTimeout(() => {
        this.loading = false
      }, '250')
    },
    decrementQty() {      
      this.$refs.quantity.value--
      this.$refs.quantity.dispatchEvent(new Event('input'))
    },
    incrementQty() {      
      this.$refs.quantity.value++
      this.$refs.quantity.dispatchEvent(new Event('input'))
    }
  },
  template: `
    <div class="[ flex items-center ][ h-[40px] max-w-min ][ border border-white ]">
      <button class="[ h-full ][ px-[10px] ]" @click="decrementQty">-</button>
      <input v-if="!loading" ref="quantity" class="[ h-full w-[30px] ][ !p-0 !border-0 ][ bg-transparent ][ text-center text-white ]" type="number" name="quantity" min="1" v-model="quantity" @input="updateItemQty(item.variant_id, $event.target.value)">  
      <div v-else class="[ h-full w-[30px] ][ flex items-center justify-center ]">
        <span class="loader"></span>
      </div>
      <button class="[ h-full ][ px-[10px] ]" @click="incrementQty">+</button>
    </div>
  `
})

var cart = {};

var app = new Vue({
  el: '#sb-cart',
  delimiters: ['${', '}'],
  data() {
    return {
      cart,      
    }
  },
  methods: {
    updateOpenState(value) {
      this.open = value
    },
    fetchCart() {
      
      fetch('/cart.js', {
        method: "GET",
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then((response) => {
        response.json().then((data) => {
          this.cart = data;          
        });
      })
      .catch((err) => {
        console.error(err);
      });      
    },
    openCart() {
      document.querySelector('.cart-drawer').classList.add('is-open')
    },
    closeCart() {
      document.querySelector('.cart-drawer').classList.remove('is-open')
    }
  },
  updated() {
    this.fetchCart();
  },
  mounted() {
    this.fetchCart();
  }
})

var app2 = new Vue({
  el: '#atc-form',
  delimiters: ['${', '}'],
  data() {
    return {
      cart      
    }
  },
  methods: {
    addToCart() {
      let variantId = this.$el.querySelector('input[name="id"]:checked').getAttribute('id');
      let quantity = this.$el.querySelector('input[name="quantity"]').value;  
    
      let data = {
        'id': `${variantId}`,
        'quantity': quantity
      }    
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {          
        return response.json();        
      })
      .catch((error) => {
        console.error('Error:', error);
      });
      setTimeout(() => {
        document.querySelector('.cart-drawer').classList.add('is-open')
      }, '250')      
    },
    decrementQty() {
      if( this.$refs.productQty.value != 1 ) {
        this.$refs.productQty.value--
      }
    },
    incrementQty() {
      this.$refs.productQty.value++
    },    
    fetchCart() {
      
      fetch('/cart.js', {
        method: "GET",
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then((response) => {
        response.json().then((data) => {
          this.cart = data;            
        });
      })
      .catch((err) => {
        console.error(err);
      });      
    },
  },
  updated() {
    this.fetchCart();
  },
  mounted() {
    this.fetchCart();
  }
})
